/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PatientUserMemoTypename = "PatientUserMemo" as const;

/**
 *
 * @export
 * @interface PatientUserMemo
 */
export interface PatientUserMemo {
  /**
   *
   * @type {string}
   * @memberof PatientUserMemo
   */
  content?: string;
  /**
   *
   * @type {string}
   * @memberof PatientUserMemo
   */
  from?: string;
  /**
   *
   * @type {number}
   * @memberof PatientUserMemo
   */
  memoId?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PatientUserMemo
   */
  readonly __typename?: string;
}

export function PatientUserMemoFromJSON(json: any): PatientUserMemo {
  return PatientUserMemoFromJSONTyped(json, false);
}

export function PatientUserMemoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientUserMemo {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PatientUserMemoTypename,

    content: !exists(json, "content") ? undefined : json["content"],
    from: !exists(json, "from") ? undefined : json["from"],
    memoId: !exists(json, "memo_id") ? undefined : json["memo_id"],
  };
}

export function PatientUserMemoToJSON(object?: PatientUserMemo | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    content: value.content,
    from: value.from,
    memo_id: value.memoId,
  };
}
